import styled from "styled-components";

// ShopList

export const ContainerListProduct = styled.div`
    display: block;
    // background-color: #F5F5F5;
`

export const BoxTituloPagina = styled.div`
    margin: auto;
    // justify-content: space-between;
    gap:80px;
    // display: flex;
    padding: 0 5%;

    @media (max-width: 425px) {
     display: block;
     border-bottom: solid 1px #848484;
    
    }

    @media (max-width: 768px) {
     display: block;
     border-bottom: solid 1px #848484;

    }
`
export const ContainerProdutos = styled.div`
    display: flex;
    // margin: 5px;
    justify-content: center;
    // padding: 0 5%;

    @media (max-width: 425px) {
        display: block;
         padding: 0 0%;
    }
    @media (max-width: 768px) {
        display: flex;
        margin: 10px;
    }

    @media (max-width: 320px) {
        display: flex;
    }
`

export const BoxProdutosFiltro1 = styled.div`
    margin: 10px;
    display: block;

    @media (max-width: 425px) {
    display:none;
    }
    
    
`

export const BoxProdutosFiltro = styled.div`
    margin: 10px;
    display: block;

    // @media (max-width: 425px) {
    // margin: 5px;
    // }
    
    // @media (max-width: 768px) {
    // margin: 5px;
    // }
`



// export const BoxCardsProdutosMobile = styled.div`
//     // display: block;
//     // gap: 25px;
//     // margin: 5px;

//     // @media (max-width: 425px) {
//     // display: block;
//     // }

//     // @media (max-width: 768px) {
//     // display: block;
//     // }

//     // @media (max-width: 1440px) {
//     // display: none;
//     // }

//     @media (max-width: 1024px) {
//     display: block;
//     }
    
// `

// export const BoxCardsProdutos = styled.div`
//     // display: block;
//     // gap: 25px;
//     // margin: 5px;

//     // @media (max-width: 425px) {
//     // display: block;
//     // }

//     // @media (max-width: 768px) {
//     // display: block;
//     // }

//     @media (max-width: 1024px) {
//     display: none;
//     }

//     @media (min-width: 1440px) {
//     display: block;
//     }
    
// `

// export const BoxCardsProdutosMobile = styled.div`
//     display: none;

//     @media (min-width: 320px) and (max-width: 1024px) {
//         display: block;
//     }
    
//     @media (min-width: 1440px) {
//         display: none;
//     }
// `;

// export const BoxCardsProdutos = styled.div`
//     display: none;

//     @media (min-width: 1440px) {
//         display: block;
//     }
// `;

export const BoxCardsProdutosMobile = styled.div`
    display: none;

    @media (min-width: 320px) and (max-width: 1024px) {
        display: block;
    }
    
    @media (min-width: 1440px) {
        display: none;
    }

    @media (width: 1024px) {
        display: flex;
        gap: 18px;
    }
`;

export const BoxCardsProdutos = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr); /* 3 cards por linha */
    gap: 20px;

    // @media (max-width: 2000px) {
    //     grid-template-columns: repeat(5, 1fr);
    // }

    @media (max-width: 2057px) {
        grid-template-columns: repeat(5, 1fr);
    }

    @media (max-width: 2400px) {
        grid-template-columns: repeat(6, 1fr);
    }
    
     @media (max-width: 2077px) {
        grid-template-columns: repeat(5, 1fr);
    }

     @media (max-width: 1707px) {
        grid-template-columns: repeat(4, 1fr);
    }

     @media (max-width: 1338px) {
        grid-template-columns: repeat(3, 1fr);
    }

     @media (max-width: 1009px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    // @media (max-width: 1440px) {
    //     grid-template-columns: repeat(4, 1fr);
    // }

    // @media (max-width: 1400px) {
    //     grid-template-columns: repeat(4, 1fr);
    // }
    
    // @media (max-width: 1024px) {
    //     grid-template-columns: repeat(3, 1fr);
    // }

    //  @media (max-width: 375px) {
    //     grid-template-columns: repeat(2, 1fr);
    // }
`;



export const TituloP = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: 0.6px;

    @media (max-width: 425px) {
    white-space: nowrap;
    margin:0;
    font-size: 32px;
    }

    @media (max-width: 768px) {
    white-space: nowrap;
    margin:0;
    font-size: 32px;
    }
`

export const DescricaoP = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.69px;

    @media (max-width: 425px) {
    font-size: 13px;
    }

    @media (max-width: 768px) {
    font-size: 13px;
    }

    @media (width: 1024px) {
    width: 706px;
    }

    @media (width: 1440px) {
    width: 706px;
    }
`


export const OrdenadoP = styled.p`
    color: #D2D2D2;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-right: 5px;
`

export const OrdenP = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin: 0;
    margin-right: 5px;
`

export const FiltroSelecionado = styled.div`
    display: flex;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    background: #EEE;
    cursor: pointer;
`

export const TituloFiltro = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 18.4px;
    font-style: normal;
    font-weight: 700;
    line-height: 31.2px;
    letter-spacing: 0.69px;
`

export const ApagarTudo = styled.p`
   color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.69px;
    text-decoration-line: underline;
    cursor: pointer;
`

export const FiltroSP = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.69px;
    margin: 0;
`

export const NomeProdutoP = styled.p`
    color: #3D3D3D;
    font-family: Montserrat;
    font-size: 16.336px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.6px;

    @media (max-width: 768px) {
    font-size: 15px;
    }

    @media (max-width: 425px) {
    font-size: 15px;
    }

    @media (max-width: 375px) {
    font-size: 14px;
    }

    @media (max-width: 320px) {
    font-size: 12px;
    }
`

export const PReviews = styled.p`
    color: #3D3D3D;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.805px;

    @media (max-width: 768px) {
    white-space: nowrap;
    font-size: 11px;
    }

    @media (max-width: 425px) {
    white-space: nowrap;
    font-size: 11px;
    }

    @media (max-width: 375px) {
    white-space: nowrap;
    font-size: 11px;
    
    }

    @media (max-width: 320px) {
    white-space: nowrap;
    font-size: 11px;
    }
`


export const CardProdutoList = styled.div`
    cursor: pointer;

    @media (max-width: 425px) {
    margin:0px;
    }

    @media (max-width: 768px) {
    margin:10px;
    display:inline-block;
    }

    @media (max-width: 320px) {
    margin:4px;
    }

    @media (min-width: 1024px) {
    margin-bottom: 20px;
    }

    @media (min-width: 1440px) {
    margin-bottom: 20px;
    }
`

export const ContainerInstaCards = styled.div`
    @media (min-width: 1440px) {
    display:flex;
    }
`

export const ValorInicialP = styled.p`
    color: #D2D2D2;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-decoration: line-through;
`

export const ValorNovoP = styled.p`
    color: #3D3D3D;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`


export const BoxProductInfo = styled.div`
    margin: 5px;
`

export const BoxInfoClassific = styled.div`
    display: flex;
    align-items: center;
`

export const BoxValoresProduct = styled.div`
    display: flex;
    margin-top: 15px;
`

export const BoxSelecaoFiltro = styled.div`
    margin: 5px;
    display: flex;

    @media (max-width: 425px) {
     display: none;
    }

    // @media (max-width: 768px) {
    //  display: none;
    // }
`

export const RemoverFiltro = styled.div`
    margin-left: 10px;
    display: flex;
    align-items: center;
`

export const BoxEscolherFiltro = styled.div`
    margin: 5px;
    margin-bottom: 20px;

    @media (max-width: 425px) {
    display: none;
    }

    // @media (max-width: 768px) {
    // display: none;
    // }
`

export const BoxCheckFiltro = styled.div`
`

export const CheckFiltro = styled.div`
    display: flex;
    margin-bottom: 5px;
`

//Instagram


export const ContainerInsta = styled.div`
    display: flex;
    padding: 78px 90px 77.93px 90px;
    justify-content: center;
    align-items: center;
`

export const ProductsInstagram = styled.div`
    display: flex;
    width: 1260px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 35px;
    flex-shrink: 0;

    @media (max-width: 768px) {
    width: 0px;
    }

    @media (max-width: 425px) {
    width: 0px;
    }

    @media (max-width: 1024px) {
    width: 100%;
    }
`

export const ListInsta = styled.div`
    // display: flex;

    // @media (width: 768px) {
    // display: inline-grid;
    // }

    // @media (width: 1024px) {
    // display: inline-grid;
    // }

    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 3 cards por linha */

    @media (max-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 425px) {
        grid-template-columns: repeat(2, 1fr);
    }
`

export const CardProdutoInsta = styled.div`
    background: #D2D2D2;
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    // position: relative; 
    transition: background 0.3s;
    cursor: pointer;
    margin: 7px;

    &:hover {
        background: #B2B2B2;
    }

     &:hover p {
        opacity: 1;
    }

    @media (max-width: 768px) {
    width: 177px;
    height: 177px;
    }

    @media (max-width: 425px) {
    width: 177px;
    height: 177px;
    }

    @media (width: 375px) {
    width: 165px;
    height: 165px;
    }

    @media (width: 320px) {
    width: 140px;
    height: 140px;
    }
`

export const Title = styled.p`
    opacity: 0; 
    transition: opacity 0.3s;
    position: absolute;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    font-family: Montserrat;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    
`;

export const PDInsta = styled.p`
    color: #3D3D3D;
    text-align: center;
    font-family: Montserrat;
    font-size: 23.25px;
    font-style: normal;
    font-weight: 700;
    line-height: 31.2px; /* 134.194% */
    letter-spacing: 0.6px;
    margin: 0;

    @media (max-width: 768px) {
    white-space: nowrap;
    font-size: 23px;
    }

    @media (max-width: 425px) {
    white-space: nowrap;
    font-size: 23px;
    }
    @media (max-width: 375px) {
    white-space: nowrap;
    font-size: 20px;
    }
    @media (max-width: 320px) {
    white-space: nowrap;
    font-size: 18px;
    }
`

export const PVerMais = styled.p`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 27.13px; /* 169.562% */
    letter-spacing: 0.69px;
    margin: 0;
    cursor: pointer;

    @media (max-width: 768px) { 
    white-space: nowrap;
    }

    @media (max-width: 425px) { 
    white-space: nowrap;
    }
`

export const Descricoes = styled.div`
    display: inline-flex;
    padding: 95px 120px 94px 120px;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) { 
    padding: 39px 30px 38px 30px;
    }

    @media (max-width: 425px) { 
    padding: 39px 30px 38px 30px;
    }
`

export const ContainerAllProducts = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
`

export const TituloAllProducts = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: 0.6px;
    margin:0;
    margin-bottom:10px;

    @media (max-width: 768px) { 
    font-size: 35px;
    width: auto;
    line-height: 45px;
    }

    @media (max-width: 425px) { 
    font-size: 35px;
    width: auto;
    line-height: 45px;
    }

    @media (max-width: 375px) { 
    font-size: 30px;
    }

    @media (max-width: 320px) { 
    font-size: 25px;
    line-height: 40px;
    }
`

export const DescricaoAllProducts = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.69px;
    margin:0;

    @media (max-width: 768px) { 
    font-size: 15px;
    }

    @media (max-width: 425px) { 
    font-size: 15px;
    }

    @media (max-width: 375px) { 
    font-size: 13px;
    }

    @media (max-width: 320px) { 
    font-size: 12px;
    }
`

export const ImgProduto = styled.div`
    height: 280px;
    width: 295px;
    border-radius: 20px;
    background: #F5F5F5;

    @media (max-width: 768px) {
    height: 175px;
    width: auto;
    display:flex;
    align-items: flex-end;
    }

    @media (max-width: 425px) {
    height: 175px;
    width: auto;
    display:flex;
    align-items: flex-end;
    }

    @media (max-width: 375px) {
    height: 160px;
    }

    @media (max-width: 320px) {
    height: 140px;
    }
`

export const ContainerBoxProdutos = styled.div`
    @media (max-width: 425px) {
    display:flex;
    margin:0;
    margin-bottom:20px;
    // gap:18px;
    // align-items: center;
    justify-content: center;
    }

    @media (max-width: 375px) {
    // gap:15px;
    }

    @media (max-width: 320px) {
    gap:0px;
    }

    @media (min-width: 1440px) {
    display:flex;
    gap:18px;
    }

`